import { BonusClassification, getBonusClassificationTranslationId } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { ReactNode } from 'react';

import { PoolSelect } from '../../select';
import { useFilter } from '../context';

export interface BonusClassificationFilterProps {
    bonusClassifications: BonusClassification[];
}

export const BonusClassificationFilter = (props: BonusClassificationFilterProps) => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (bonusClassification?: BonusClassification) => {
        filter.delete('bonusClassification');
        if (bonusClassification) {
            filter.set('bonusClassification', bonusClassification);
        }
        updateFilter(filter);
    };

    const getDisplayValue = (statusValue: unknown): ReactNode => {
        if (typeof statusValue !== 'string') {
            return '';
        }

        return <FormattedMessage id={getBonusClassificationTranslationId(statusValue as BonusClassification)} />;
    };

    registerFilterMap('bonusClassification', getDisplayValue);

    return (
        <PoolSelect
            displayEmpty={true}
            name="bonusClassification"
            label={<FormattedMessage id="app.contactsAndOrganizations.detail.bonusClassification" />}
            fullWidth={true}
            value={filter.get('bonusClassification')}
            onValueChange={onSelected}
            noSorting={true}
            options={props.bonusClassifications.map(bonusClassification => {
                return {
                    value: bonusClassification,
                    displayValue: bonusClassification ? (
                        <FormattedMessage id={getBonusClassificationTranslationId(bonusClassification)} />
                    ) : (
                        ''
                    ),
                };
            })}
        />
    );
};
